import Vue from 'vue'
import router from '../router'
import Vuex from 'vuex'
import { listingModel } from '../dataModel.js'
import moment from 'moment'
import { getUserLatestNpsScore } from '../platform/analytics/services/usageStatsService.js'
import { getField, updateField } from 'vuex-map-fields';
import { getPrivatePerson, getJuridicalPerson, getConnectedJurPersons } from '../platform/person/repository/personRepository'
import { getCurrentUserAccounts, getAccountPersons } from '../platform/account/services/accountService'
import { getDeals, filterDeals, getAccountDealIds, getDealById } from '../bookings/bookingsService'
import { getDealSnapshots, createDealSnapshot, updateDeal } from '@/platform/deals/services/dealsService.js'
import { ALLOWED_BOOKINGS_STATUSES } from "@/bookings/bookingUtil.js"
import { createDeal } from "@/bookings/bookingsService.js";
import { cloneListing, checkPropertyAddress } from "@/listings/repository/listingRepository.js"
import { getListingPrivate } from "@/listings/repository/listingRepository";
import { getAnyCurrentUser, logOutAuthUser, clearAllUserTraces } from '@/platform/auth/services/authService.js'
import { getListingVisits } from '@/platform/analytics/repositories/analyticsRepository.js';
import { getRentPrediction } from '@/pricing/services/pricingService.js';
import { captureException } from '@/utils/reporting/reportingService.js';
import PropertyCalendarModule from '@/vuex/property-calendar';
import ContractTemplatesModule from '@/vuex/contract-templates';
import ChatModule from '@/vuex/chat';
import InternationalizationModule from '@/vuex/internationalization';
import AccountModule from '@/vuex/account';
import * as dealsRepository from '../dealsRepository';
import { uploadNote, getPropertyNotes } from '../notesRepository.js'
import BackStack from '@/platform/infra/BackStack'
import { updateFees } from '@/listings/repository/listingRepository';
import { filterProperties } from '../listingFunctions';
import { signAccomodationAgreement } from "../platform/contracts/services/contractService";

Vue.use(Vuex)
const USER_VIEW_ROLES = ["tenant", "landlord"]
const DEFAULT_USER_VIEW_ROLE = USER_VIEW_ROLES[1]

const utilityModule = {
  state: {
    userViewRole: DEFAULT_USER_VIEW_ROLE,
    rentPricePrediction: {
      price: "",
      similarProperties: [],
      loading: true,
      err: false
    },
    connected: true,
    termsAndConditions: "",
    accomodationTerms: "",
    backstack: new BackStack(),
    showTutorial: false,
    tutorialMessage: ""
  },
  getters: {
    tutorialMessage: state => state.tutorialMessage,
    backstack: state => state.backstack,
    showTutorial: state => state.showTutorial,
    connected: state => state.connected,
    utilityModule: state => state,
    termsAndConditions: state => state.termsAndConditions,
    accomodationTerms: state => state.accomodationTerms,
    rentPricePrediction: state => state.rentPricePrediction,
    userViewRole: state => state.userViewRole
  },
  mutations: {
    SET_SHOW_TUTORIAL(state, {show,message}){
      state.showTutorial = show
      if(show) state.tutorialMessage = message
      else state.tutorialMessage = ""
    },
    SET_USER_VIEW_ROLE(state, payload){
      state.userViewRole = payload
      if(state.backstack) state.backstack.clear()
    },
    SET_RENT_PRICE_PREDICTION(state, { price, similarProperties, loading, err }) {
      price ? Vue.set(state.rentPricePrediction, "price", price) : void 0;
      similarProperties ? Vue.set(state.rentPricePrediction, "similarProperties", similarProperties) : void 0;
      loading ? Vue.set(state.rentPricePrediction, "loading", loading) : Vue.set(state.rentPricePrediction, "loading", false);
      err ? Vue.set(state.rentPricePrediction, "err", err) : Vue.set(state.rentPricePrediction, "err", false);
    },
    SET_TERMS_AND_CONDITIONS(state, payload) {
      state.termsAndConditions = payload
    },
    SET_ACCOMODATION_TERMS(state, payload){
      state.accomodationTerms = payload
    },
    SET_CONNECTED(state, payload) {
      state.connected = payload
    },
  },
  actions: {
    editUserViewRole({commit}, viewRole){
      if(viewRole && USER_VIEW_ROLES.includes(viewRole)) {
        commit("SET_USER_VIEW_ROLE", viewRole)
        localStorage.setItem("user_view_role", viewRole)
        return true
      }else return false
    },
    setRentPricePrediction({ commit }, predictionQuery) {
      commit("SET_RENT_PRICE_PREDICTION", { loading: true })
      getRentPrediction(predictionQuery)
        .then(result => {
          commit("SET_RENT_PRICE_PREDICTION", result)
        })
        .catch(err => {
          commit("SET_RENT_PRICE_PREDICTION", { err: err })
        });
    },
    setConnected({ commit }, payload) {
      commit('SET_CONNECTED', payload)
    },
  }
}

let initialStateUser = {
  user: {},
  privatePerson: {},
  jurPersons: [],
  isUserVerified: false,
  isUserEmailVerified: false,
  isUserLoggedIn: false,
  loadingUser: true,
  chatEnabled: false,
  askNps: false
}

const userModule = {
  state: {
    user: {},  // NOTE: this will be system user, NOT firebase user
    privatePerson: {},
    jurPersons: [],
    isUserVerified: false,
    isUserEmailVerified: false,
    isUserLoggedIn: false,
    loadingUser: true,
    chatEnabled: false,
    askNps: false,
    connectedAccountIds: [],
    accountIdsMemory: {}
  },
  getters: {
    user: state => state.user,
    isUserVerified: state => state.isUserVerified,
    isUserEmailVerified: state => state.isUserEmailVerified,
    loadingUser: state => state.loadingUser,
    isUserLoggedIn: state => state.isUserLoggedIn,
    userModule: state => state,
    chatEnabled: state => state.chatEnabled,
    askNps: state => state.askNps,
    privatePerson: state => state.privatePerson,
    jurPersons: state => state.jurPersons,
    connectedAccountIds: state => state.connectedAccountIds,
    selectedAccount: state => state.connectedAccountIds[0]
  },
  mutations: {
    SET_ACCOUNT_IDS_IN_MEM(state, { userUid, accountIds }) {
      state.accountIdsMemory[userUid] = accountIds
    },
    SET_CONNECTED_ACCOUNT_IDS(state, payload) {
      state.connectedAccountIds = payload
    },
    RESET_CONNECTED_ACCOUNT_IDS(state, payload) {
      state.connectedAccountIds = []
    },
    SET_ASK_NPS(state, payload) {
      state.askNps = payload
    },
    SET_USER_DATA(state, payload) {
      state.user = payload
      state.chatEnabled = payload.chatEnabled
    },
    SET_USER_UID(state, uid) {
      Vue.set(state.user, "uid", uid)
    },
    SET_USER_PIC_URL(state, picUrl) {
      Vue.set(state.user, "pictureUrl", picUrl)
    },
    SET_CHAT_ENABLED(state, payload) {
      state.chatEnabled = payload
    },
    SET_IS_USER_VERIFIED(state, payload) {
      state.isUserVerified = payload
    },
    SET_IS_USER_EMAIL_VERIFIED(state, payload) {
      state.isUserEmailVerified = payload
    },
    SET_ACCOUNT_PRIV_PERSON(state, payload) {
      state.privatePerson = payload
    },
    SET_USER_JUR_PERSONS(state, payload) {
      state.jurPersons = payload
    },
    ADD_ACCOUNT_JUR_PERSON(state, payload) {
      state.jurPersons.push(payload)
    },
    REPLACE_ACCOUNT_JUR_PERSON(state, payload) {

      for (var i = 0; i < state.jurPersons.length; i++) {
        if (state.jurPersons[i]._id == payload._id) {
          Vue.set(state.jurPersons, i, payload)
        }
      }
    },
    RESET_USER_JUR_PERSONS(state) {
      state.jurPersons = [];
    },
    IS_LOADING_USER(state, payload) {
      state.loadingUser = payload
    },
    SET_IS_LOGGED_IN(state, payload) {
      state.isUserLoggedIn = payload
    },
    RESET_USER_DATA(state) {
      state.user = JSON.parse(JSON.stringify(initialStateUser.user));
      state.isUserVerified = JSON.parse(JSON.stringify(initialStateUser.isUserVerified));
      state.isUserLoggedIn = JSON.parse(JSON.stringify(initialStateUser.isUserLoggedIn));
      state.loadingUser = JSON.parse(JSON.stringify(initialStateUser.loadingUser));
      state.chatEnabled = JSON.parse(JSON.stringify(initialStateUser.chatEnabled));
      state.jurPersons = [];
      state.privatePerson = JSON.parse(JSON.stringify(initialStateUser.privatePerson));
    },
    REMOVE_PRIVATE_PERSONS_FILE({ privatePerson }, fileName) {
      if (!Array.isArray(privatePerson.files) || !privatePerson.files.length || !fileName) {
        return;
      }
      const index = privatePerson.files.indexOf(fileName);
      if (index < 0) {
        return;
      }
      privatePerson.files.splice(index, 1);
    },
    SET_PRIVATE_PERSONS_FILES({ privatePerson }, fileNames) {
      if (!Array.isArray(fileNames)) {
        return;
      }
      Vue.set(privatePerson, 'files', fileNames);
    },
  },
  actions: {
    retrieveAccountPersons({ dispatch, commit }, { accountId }) {
      getAccountPersons(accountId)
        .then(personIds => {
          if(personIds && personIds.length > 0){
            personIds[0].privPersonId ? dispatch("setAccountPrivatePerson", personIds[0].privPersonId) : void 0;
            personIds[0].jurPersonId ? dispatch("setAccountJuridicalPerson", personIds[0].jurPersonId) : void 0;
          }
        })
        .catch(err => {
        })
    },
    async retrieveUserAccountIds({ state, commit, dispatch }, { userUid }) {
        if (state.accountIdsMemory[userUid] && state.accountIdsMemory[userUid].length > 0) {
          commit("SET_CONNECTED_ACCOUNT_IDS", state.accountIdsMemory[userUid])
          return state.accountIdsMemory[userUid]
        }

        try {
          var accounts = await getCurrentUserAccounts()
          var accountIds = []
          for (var i = 0, n = accounts.length; i < n; i++) {
            accounts[i].accountId ? accountIds.push(accounts[i].accountId) : void 0;
          }
          commit("SET_ACCOUNT_IDS_IN_MEM", { userUid, accountIds })
          commit("SET_CONNECTED_ACCOUNT_IDS", accountIds)

          return accountIds;
        } catch (error) {
          captureException(error)
          return []
        }
    },
    setAccountPrivatePerson({ commit, dispatch }, personId) {
      if (personId) {
        commit("SET_ACCOUNT_PRIV_PERSON", { state: "loading" })
        getPrivatePerson({ id: personId })
          .then(person => {
            commit("SET_ACCOUNT_PRIV_PERSON", person)
          })
          .catch(err => {
            console.log('setAccountPrivatePerson > err:', err);
            
          })
      }
    },
    setAccountJuridicalPerson({ commit, dispatch }, personId) {
      if (personId) {
        commit("ADD_ACCOUNT_JUR_PERSON", { state: "loading", _id: personId })
        getJuridicalPerson({ id: personId })
          .then(person => {
            commit("REPLACE_ACCOUNT_JUR_PERSON", person)
          })
          .catch(err => {
          })
      }
    },
    decideToAskNpsOfUser({ commit }, payload) {
      if (!payload || !payload.user || !payload.createdDate) return;
      else {
        var cDate = new Date(payload.user.createdDate);
        var today = new Date()
        var res = Math.abs(today - cDate) / 1000;
        var userAge = Math.floor(res / 86400);
        if (userAge < 14) return;  // lets not ask from new users
      }
      getUserLatestNpsScore(payload.user.uid)
        .then(resp => {
          if (resp && resp.reportedAt_unix) {
            var latestNpsScoreGivenOn = resp.reportedAt_unix
            var now = moment().unix()
            var deltaInDays = (now - latestNpsScoreGivenOn) / 86400
            commit("SET_ASK_NPS", deltaInDays >= 30)  // we ask NPS after every 30 days
          }
        })
        .catch(err => {
          if (err == 404) commit("SET_ASK_NPS", true)
        })
    },
    deleteAuthUser({ commit, getters }, authUser){
      try{
        authUser.delete()
          .then(res => {
            console.log('store.deleteAuthUser > done ');
            clearAllUserTraces()
          })
          .catch(err => {
            // An error happened.
            console.log('store.deleteAuthUser.delete() > err: ', err);
          });
      }catch(ex){
        console.log('store.deleteAuthUser > err: ', err);
      }
    },
    async logout({ commit, getters }, payload) {
      try {
        await logOutAuthUser()
        clearAllUserTraces()
      } catch (err) {
        captureException(err)
      }
    },
    async REMOVE_PRIVATE_PERSONS_FILE({ getters, commit, dispatch }, { accountId, fileName }) {
      try {
          commit('REMOVE_PRIVATE_PERSONS_FILE', fileName);
          dispatch('savePrivateFiles', {
              accountId,
              fileNames: getters.privatePerson.files || [],
          });
      }
      catch (error) {
          console.log(error);
      }
      finally {

      }
    },
  }
}


const listingsPortalModule = {
  state: {
    filteredListings: {},
    sortedListings: {}
  },
  getters: {
    filteredListings: state => state.filteredListings,
    sortedListings: state => state.sortedListings,
    listingsPortalModule: state => state
  },
  mutations: {
    setFilteredListings(state, listings) {
      state.filteredListings = listings;
    },
    setSortedListings(state, listings) {
      state.sortedListings = listings;
    }
  }
}
const readOnceValuesModule = {
  state: {
    uidOfChatToStart: '',
    chatStartPayload: ''
  },
  getters: {
    uidOfChatToStart: state => state.uidOfChatToStart,
    chatStartPayload: state => state.chatStartPayload,
    readOnceValuesModule: state => state.readOnceValuesModule
  },
  mutations: {
    setUidOfChatToStart(state, uid) {
      state.uidOfChatToStart = uid;
    },
    setChatStartPayload(state, payload) {
      state.chatStartPayload = payload;
    },
    RESET_READ_ONCE_VALUES(state) {
      state.uidOfChatToStart = "";
      state.chatStartPayload = "";
    }
  }
}

const listingBookingsModule = {
  state: {
    dealSnapshotInEdit: {},
    originalDeals: {},
    originalStays: {},
    dealSnapshots: {},
    snapshots: [],
    dealInView: {},
    loadingDealInView: true,
    deals: [],
    filteredDeals: [],
    stays: [],
    importedBookingIds: {},
    tenantStays: [],
    tenantStayIds: {},
    loadingDeals: true,
    loadingStays: true,
    dealCriticalErr: false,
    dealsPageLimit: 15,
    staysPageLimit: 15,
    canLoadMoreDeals: true,
    canLoadMoreStays: true,
  },
  getters: {
    latestDealSnapshot: (state) => (dealId) => {
      // var snaps = state.dealSnapshots[dealId]
      var snaps = state.dealSnapshots(dealId)
      if (snaps.length > 0) {
        return snaps[snaps.length - 1]
      } else return null
    },
    dealSnapshotInEdit: state => state.dealSnapshotInEdit,
    originalDeals: state => state.originalDeals,
    originalStays: state => state.originalStays,
    dealSnapshots: (state) => (dealId) => {
      var snapshots = []
      state.snapshots.forEach(function (entry) {
        entry.dealId == dealId ? snapshots.push(entry) : void 0;
      });
      return snapshots
    },
    loadingDeals: state => state.loadingDeals,
    loadingStays: state => state.loadingStays,
    deals: state => state.deals,
    filteredDeals: state => state.filteredDeals,
    stays: state => state.stays,
    importedBookingIds: state => state.importedBookingIds,
    tenantStays: state => state.tenantStays,
    tenantStayIds: state => state.tenantStayIds,
    dealInView: state => state.dealInView,
    loadingDealInView: state => state.loadingDealInView,
    dealCriticalErr: state => state.dealCriticalErr,
    listingBookingsModule: state => state,
    dealsPageNumber: ({ deals, dealsPageLimit }) => {
      return Math.ceil(deals.length / dealsPageLimit);
    },
    staysPageNumber: ({ stays, staysPageLimit }) => {
      return Math.ceil(stays.length / staysPageLimit);
    },
    canLoadMoreDeals: ({ canLoadMoreDeals }) => canLoadMoreDeals,
    canLoadMoreStays: ({ canLoadMoreStays }) => canLoadMoreStays,
  },
  mutations: {
    SET_DEAL_SNAPSHOT_IN_EDIT(state, snapshot) {
      // state.dealSnapshotInEdit = {}
      Vue.set(state.dealSnapshotInEdit, {})
      for (var key of Object.keys(snapshot)) {
        Vue.set(state.dealSnapshotInEdit, key, snapshot[key])
      }
    },
    UPDATE_DEAL_SNAPSHOT_IN_EDIT_ROOTS(state, rootLevelUpdates) {
      for (var key of Object.keys(rootLevelUpdates)) {
        Vue.set(state.dealSnapshotInEdit, key, rootLevelUpdates[key])
      }
    },
    SET_ORIGINAL_DEAL(state, deal) {
      state.originalDeals[deal._id] = deal
    },
    SET_DEAL_SNAPSHOTS(state, { dealId, snapshots }) {
      state.snapshots = snapshots
      // state.dealSnapshots[dealId] = snapshots;
    },
    ADD_SNAPSHOTS(state, snapshots) {
      state.snapshots = state.snapshots.concat(snapshots);
    },
    ADD_DEAL_SNAPSHOT(state, { dealId, snapshot }) {
      state.snapshots.push(snapshot)
      // var snaps = []
      // snaps.push(snapshot)
      // if (!state.dealSnapshots[dealId]){
      //   Vue.set(state.dealSnapshots, dealId, snaps)
      // } else{
      //   var allSnaps = state.dealSnapshots[dealId]
      //   Vue.set(state.dealSnapshots, dealId, allSnaps.concat(snaps))
      // }
    },
    RESET_ALL_DEAL_SNAPSHOTS(state) {
      state.snapshots = []
      // state.dealSnapshots = {}
    },
    SET_LOADING_DEAL_IN_VIEW(state, payload) {
      state.loadingDealInView = payload
    },
    SET_DEAL_IN_VIEW(state, payload) {
      state.dealInView = payload
    },
    SET_LOADING_DEALS(state, payload) {
      state.loadingDeals = payload;
    },
    SET_LOADING_STAYS(state, payload) {
      state.loadingStays = payload;
    },
    ADD_NEW_STAY(state, stay) {
      if (state.originalStays[stay._id]) {
        return;
      }
      state.originalStays[stay._id] = stay;
      state.stays.push(stay);
    },
    REPLACE_STAY(state, stay) {
      for (var i = 0; i < state.stays.length; i++) {
        if (state.stays[i]._id == stay._id) {
          Vue.set(state.stays, i, stay)
        }
      }
      state.originalStays[stay._id] = stay;
    },
    REMOVE_STAY(state, id) {
      var index = -1
      for (var i = 0; i < state.stays.length; i++) {
        if (state.stays[i]._id == id) {
          index = i
          break;
        }
      }
      if (index > -1) state.stays.splice(index, 1);
      Vue.delete(state.originalStays, id);
    },
    RESET_STAY_STATE(state) {
      state.stays = [];
      state.originalStays = {};
      state.tenantStays = []
      state.tenantStayIds = {}
      state.canLoadMoreStays = true;
    },
    ADD_NEW_DEAL(state, deal) {
      if (state.originalDeals[deal._id]) {
        return;
      }
      state.originalDeals[deal._id] = deal;
      state.deals.push(deal);
    },
    REPLACE_DEAL(state, deal) {
      for (var i = 0; i < state.deals.length; i++) {
        if (state.deals[i]._id == deal._id) {
          Vue.set(state.deals, i, deal)
        }
      }
      state.originalDeals[deal._id] = deal;
    },
    REMOVE_DEAL(state, id) {
      var bookingIndex = -1
      for (var i = 0; i < state.deals.length; i++) {
        if (state.deals[i]._id == id) {
          bookingIndex = i
          break;
        }
      }
      if (bookingIndex > -1) state.deals.splice(bookingIndex, 1);
      Vue.delete(state.originalDeals, id);
    },
    RESET_DEAL_STATE(state) {
      state.originalDeals = {}
      // state.dealSnapshots = {}
      state.snapshots = []
      state.deals = []
      state.filteredDeals = [];
      state.canLoadMoreDeals = true;
    },
    UPDATE_DEAL_ACCOMODATION_SIGNATURES(state, { dealId, update, signerType }){
      console.log('UPDATE_DEAL_ACCOMODATION_SIGNATURES:', dealId, update, signerType);
      for (let i = 0; i < state.deals.length; i++) {
          if (state.deals[i]._id === dealId) {
          const deal = state.deals[i];
          if (!deal.signatures) {
              Vue.set(deal, 'signatures', { accomodation: {} });
          }
          // Vue.set(state.deals[i].signatures.accomodation, signerType, update);
          Vue.set(deal.signatures.accomodation, signerType, update);
          Vue.set(state.deals, i, deal);
          console.log('state.deals[i]:', state.deals[i]);
          break;
        }
      }
        for (let i = 0; i < state.stays.length; i++) {
            if (state.stays[i]._id === dealId) {
                const stay = state.stays[i];
                if (!stay.signatures) {
                    Vue.set(stay, 'signatures', { accomodation: {} });
                }
                // Vue.set(state.stays[i].signatures.accomodation, signerType, update);
                Vue.set(stay.signatures.accomodation, signerType, update);
                Vue.set(state.stays, i, stay);
                console.log('state.stays[i]:', state.stays[i]);
                break;
            }
        }
    },
    UPDATE_BOOKING_STATUS(state, { dealId, status }) {
      for (var i = 0; i < state.deals.length; i++) {
        if (state.deals[i]._id == dealId) {
          state.deals[i].status = status
            break;
        }
      }
      for (var i = 0; i < state.stays.length; i++) {
        if (state.stays[i]._id == dealId) {
          state.stays[i].status = status
            break;
        }
      }
      state.dealInView._id == dealId ? state.dealInView.status = status : void 0;
    },
    UPDATE_BOOKING_PAYMENT_STATUS(state, { dealId, status }) {
      for (var i = 0; i < state.deals.length; i++) {
        if (state.deals[i]._id == dealId) {
          state.deals[i].paymentStatus = status;
          break;
        }
      }
      for (var i = 0; i < state.stays.length; i++) {
        if (state.stays[i]._id == dealId) {
          state.stays[i].paymentStatus = status;
          break;
        }
      }
      state.dealInView._id == dealId ? state.dealInView.paymentStatus = status : void 0;
    },
    SET_DEAL_CRITICAL_ERR(state, payload) {
      state.dealCriticalErr = payload;
    },
    ADD_DEAL_DOCUMENTS({ dealInView }, documents) {
      if (!Array.isArray(documents)) {
        return;
      }
      if (!dealInView.documentDet) {
        Vue.set(dealInView, 'documentDet', {});
      }
      Vue.set(dealInView.documentDet, 'ownerFileNames', documents);
    },
    DELETE_DEAL_DOCUMENT({ dealInView }, fileName) {
      if (!fileName) {
        return;
      }
      if (!dealInView.documentDet || !dealInView.documentDet.ownerFileNames) {
        return;
      }
      const index = dealInView.documentDet.ownerFileNames.findIndex(name => name === fileName);
      if (index < 0) {
        return;
      }
      dealInView.documentDet.ownerFileNames.splice(index, 1);
    },
    APPEND_DEALS({ originalDeals, deals }, newDeals) {
      if (!Array.isArray(newDeals) || !newDeals.length) {
        return;
      }
      for (const deal of newDeals) {
        // Avoiding duplicates:
        if (originalDeals[deal._id]) {
          continue;
        }
          originalDeals[deal._id] = deal;
          deals.push(deal);
      }
    },
    SET_DEALS(state, deals) {
      if (!Array.isArray(deals) || !deals.length) {
        return;
      }
      const mappedDeals = {};
      for (const deal of deals) {
        mappedDeals[deal._id] = deal;
      }
      state.originalDeals = mappedDeals;
      state.deals = deals;
    },
    setCanLoadMoreDeals(state, canLoadMoreDeals) {
      state.canLoadMoreDeals = Boolean(canLoadMoreDeals);
    },
    APPEND_STAYS({ originalStays, stays }, newStays) {
      if (!Array.isArray(newStays) || !newStays.length) {
        return;
      }
      for (const stay of newStays) {
        if (originalStays[stay._id]) {
          continue;
        }
        originalStays[stay._id] = stay;
        stays.push(stay);
      }
    },
    SET_STAYS(state, stays) {
      if (!Array.isArray(stays) || !stays.length) {
        return;
      }
      const mappedStays = {};
      for (const stay of stays) {
        mappedStays[stay._id] = stay;
      }
      state.originalStays = mappedStays;
      state.stays = stays;
    },
    setCanLoadMoreStays(state, canLoadMoreStays) {
      state.canLoadMoreStays = Boolean(canLoadMoreStays);
    },
    SET_FILTERED_DEALS(state, filteredDeals) {
      if (!Array.isArray(filteredDeals)) {
        return;
      }
      state.filteredDeals = filteredDeals;
    },
    RESET_FILTERED_DEALS(state) {
      state.filteredDeals = [];
    }
  },
  actions: {
    async signDealAccomodationAgreement(context, command){
      var result = await signAccomodationAgreement(command);
      // add local signature state
      context.commit("UPDATE_DEAL_ACCOMODATION_SIGNATURES", {dealId: command.dealId, update: {timestamp: Date.now()}, signerType: command.signerType})
      if (!result){
        // remove local signature state
        context.commit("UPDATE_DEAL_ACCOMODATION_SIGNATURES", {dealId: command.dealId, update: {}, signerType: command.signerType})
      }
    },
    deleteDealInView(context, { dealId }) {
      context.commit("SET_LOADING_DEAL_IN_VIEW", true)
      context.commit("REMOVE_DEAL", dealId)
      var accountId = context.getters.connectedAccountIds[0];
      updateDeal({ updatePayload: { dealId: dealId, visibility: "deleted" }, accountId: accountId })
        .then(res => {
        })
        .catch(err => {
        })
        .finally(f => {
          context.commit("SET_LOADING_DEAL_IN_VIEW", false)
        })
    },
    // TODO: it's unused, thus can be removed
    updateDealInViewStatus(context, { dealId, status }) {
      if (!ALLOWED_BOOKINGS_STATUSES.includes(status)) return false
      const prevStatus = context.getters.dealInView.status
      context.getters.dealInView.status = status
      var accountId = context.getters.connectedAccountIds[0];
      updateDeal({ updatePayload: { dealId, status }, accountId: accountId })
        .then(res => {
        })
        .catch(err => {
          context.getters.dealInView.status = prevStatus
        })
    },
    async createSnapshot({ commit, getters, dispatch }, { dealId, snapshot, comment, inEffectDate }) {
      try {
        commit("SET_LOADING_DEAL_IN_VIEW", true);
        const accountId = getters.connectedAccountIds[0];
        const newSnapshot = await createDealSnapshot({ dealId, snapshot, comment, accountId, inEffectDate });
        delete snapshot.signatures;
        dispatch("addDealSnapshot", { dealId: dealId, snapshot: newSnapshot });
        commit("REPLACE_DEAL", snapshot);
        commit("SET_DEAL_IN_VIEW", snapshot);
      }
      catch (error) {
        captureException(error);
        throw error;
      }
      finally {
        commit("SET_LOADING_DEAL_IN_VIEW", false);
      }
    },
    addDealSnapshot: (context, { dealId, snapshot }) => {
      // Make sure snapshot in args has its _id set.
      snapshot.snapshot.snapshotId = snapshot._id //add snapshot id into snapshot (pretending to be deal)
      snapshot.snapshot._id = snapshot.dealId  // add dealid into snapshot (pretending to be deal, can be missing)
      context.commit("ADD_DEAL_SNAPSHOT", { dealId, snapshot })
      // context.commit("SET_DEAL_IN_VIEW", snapshot.snapshot)
      // context.commit("REPLACE_DEAL", snapshot.snapshot)

    },
    createNewDeal: (context, { property, lesseeDet, lessorDet, contractDetails, lessorAccountId }) => {
      return new Promise((resolve, reject) => {
        createDeal({ property, lesseeDet, lessorDet, contractDetails, lessorAccountId })
          .then(deal => {
            context.commit("ADD_NEW_DEAL", deal)
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getDealInView({ state, commit, dispatch, getters }, { dealId, snapshotId }) {
        try {
            const findDealLocally = ({ dealId, snapshotId }) => {
                if (dealId && snapshotId) {
                    const searchPool = getters.dealSnapshots(dealId) || [];
                    const snapshot = searchPool.find(item => item._id === snapshotId);
                    if (snapshot) {
                        return snapshot.snapshot;
                    }
                }
                if (state.originalDeals[dealId]) {
                    return state.originalDeals[dealId];
                }
                let deal = state.deals.find(item => item._id === dealId);
                if (deal) {
                    return deal;
                }
                deal = state.stays.find(item => item._id === dealId);
                if (deal) {
                    return deal;
                }
            };
            const requestDeal = ({ dealId }) => {
                return getAnyCurrentUser()
                    .then(user => {
                        if (user.uid) return dispatch("retrieveUserAccountIds", { userUid: user.uid })
                        else return Promise.reject("cannot get uid of user which is required for this operation")
                    })
                    .then(accountIds => {
                        return getDealById(dealId, accountIds[0])
                    })
            };
            const getDeal = async ({ dealId, snapshotId }) => {
                const deal = findDealLocally({ dealId, snapshotId });
                if (deal) {
                    return deal;
                }

                return await requestDeal({ dealId });
            };

            commit("SET_LOADING_DEAL_IN_VIEW", true);
            const deal = await getDeal({ dealId, snapshotId });
            commit("SET_DEAL_IN_VIEW", deal);
            if (getters.dealSnapshots(dealId).length) {
                return;
            }
            const snapshots = await getDealSnapshots({ dealId });
            if (!Array.isArray(snapshots) || !snapshots.length) {
                return;
            }
            for (let i = 0; i < snapshots.length; i++) {
                snapshots[i].snapshot.snapshotId = snapshots[i]._id; //add snapshot id into snapshot (pretending to be deal)
                snapshots[i].snapshot._id = dealId;  // add dealid into snapshot (pretending to be deal, can be missing)
            }
            // context.commit("SET_DEAL_SNAPSHOTS", { dealId: dealId, snapshots: snapshots })
            commit("ADD_SNAPSHOTS", snapshots);
            // var latestDealSnapshot = snapshots[snapshots.length - 1].snapshot
            // context.commit("REPLACE_DEAL", latestDealSnapshot)
        }
        catch (error) {
            console.error(error);
            commit("SET_DEAL_CRITICAL_ERR", true);
            captureException(error);
        }
        finally {
            commit("SET_LOADING_DEAL_IN_VIEW", false);
        }
    },
    getAccountDeals: async ({ commit, dispatch, state, getters }, { accountId, reload = false }) => {
      try {
          commit("SET_LOADING_DEALS", true);
          if (reload) {
              commit("RESET_DEAL_STATE");
          }
          const deals = await getDeals({
              accountId,
              viewRole: 'lessor',
              page: getters.dealsPageNumber,
              limit: state.dealsPageLimit,
          });
          await dispatch('APPEND_DEALS', deals);
      }
      catch (error) {
        console.log("store | getAccountDeals > err:", error);
      }
      finally {
          commit("SET_LOADING_DEALS", false);
      }
    },
    getAccountStays: async ({ commit, dispatch, state, getters }, { accountId, reload = false }) => {
      try {
        commit("SET_LOADING_STAYS", true);
        if (reload) {
          commit("RESET_STAY_STATE");
        }
        const deals = await getDeals({
          accountId,
          viewRole: 'lessee',
          page: getters.staysPageNumber,
          limit: state.staysPageLimit,
        });
        await dispatch('APPEND_STAYS', deals);
      }
      catch (error) {
        console.error(error);
      }
      finally {
        commit("SET_LOADING_STAYS", false);
      }
    },
    filterDeals: async ({ commit }, { accountId, searchString }) => {
        try {
            if (!accountId || !searchString) {
              return;
            }
            commit("SET_LOADING_DEALS", true);
            commit("RESET_FILTERED_DEALS");
            const deals = await filterDeals({
                accountId,
                viewRole: 'lessor',
                searchString,
            });
            commit('SET_FILTERED_DEALS', deals);
        }
        catch (error) {
            console.log("store | filterDeals > err:", error);
        }
        finally {
            commit("SET_LOADING_DEALS", false);
        }
    },
    resetFilteredDeals: ({ commit }) => {
        commit('RESET_FILTERED_DEALS');
    },

    async ADD_DEAL_DOCUMENTS({ commit, state: { dealInView } }, { accountId, documents }) {
      if (!Array.isArray(documents) || !accountId) {
        return;
      }
      if (!dealInView) {
        return;
      }
      let allFiles = [];
      if (dealInView.documentDet && dealInView.documentDet.ownerFileNames) {
        allFiles = dealInView.documentDet.ownerFileNames.concat(documents);
      }
      else {
        allFiles = documents;
      }
      commit('ADD_DEAL_DOCUMENTS', allFiles);

      await dealsRepository.upsertDocuments({
        dealId: dealInView._id,
        accountId,
        ownerFileNames: allFiles
      });
    },

    async DELETE_DEAL_DOCUMENT({ commit, state: { dealInView } }, { accountId, fileName }) {
      if (!fileName) {
        return;
      }
      if (!dealInView.documentDet || !dealInView.documentDet.ownerFileNames) {
        return;
      }
      commit('DELETE_DEAL_DOCUMENT', fileName);

      await dealsRepository.upsertDocuments({
        dealId: dealInView._id,
        accountId,
        ownerFileNames: dealInView.documentDet.ownerFileNames,
      });
    },
    SET_DEALS({ state, commit }, deals) {
        commit('SET_DEALS', deals);
        commit('setCanLoadMoreDeals', deals.length >= state.dealsPageLimit);
    },
    APPEND_DEALS({ state, commit }, deals) {
        commit('APPEND_DEALS', deals);
        commit('setCanLoadMoreDeals', deals.length >= state.dealsPageLimit);
    },
    SET_STAYS({ state, commit }, stays) {
        commit('SET_STAYS', stays);
        commit('setCanLoadMoreStays', stays.length >= state.staysPageLimit);
    },
    APPEND_STAYS({ state, commit }, stays) {
        commit('APPEND_STAYS', stays);
        commit('setCanLoadMoreStays', stays.length >= state.staysPageLimit);
    },
    async FILTER_DEALS({ commit }, searchString) {
        const filteredDeals = await void 0;
        commit('SET_FILTERED_DEALS', filteredDeals);
    },
    UPDATE_BOOKING_STATUS({ commit }, { dealId, status }) {
      commit('UPDATE_BOOKING_STATUS', { dealId, status });
    },
    UPDATE_BOOKING_PAYMENT_STATUS({ commit }, { dealId, status }) {
      commit('UPDATE_BOOKING_PAYMENT_STATUS', { dealId, status });
    },
  }
}

const listingRequestsModule = {
  state: {
    listingRequests: [],
    listingRequestIds: {},
    pricingRules: {},
    requestPromise: undefined
  },
  getters: {
    listingRequests: state => state.listingRequests,
    listingRequestIds: state => state.listingRequestIds,
    pricingRules: state => state.pricingRules,
    requestPromise: state => state.requestPromise,
    listingRequestsModule: state => state
  },
  mutations: {
    SET_LATEST_REQUEST_PROMISE(state, promise) {
      state.requestPromise = promise
    },
    SET_PRICING_RULES(state, rules) {
      state.pricingRules = rules
    },
    ADD_NEW_REQUEST(state, request) {
      state.listingRequests.push(request)
    },
    REPLACE_REQUEST(state, newRequest) {
      for (var i = 0; i < state.listingRequests.length; i++) {
        if (state.listingRequests[i].id == newRequest.id) {
          Vue.set(state.listingRequests, i, newRequest)
        }
      }
    },
    REMOVE_REQUEST(state, rId) {
      var requestIndex = -1
      for (var i = 0; i < state.listingRequests.length; i++) {
        if (state.listingRequests[i].id == rId) {
          requestIndex = i
          break;
        }
      }
      if (requestIndex > -1) state.listingRequests.splice(requestIndex, 1);
    },
    SET_REQUESTS(state, requests) {
      state.listingRequests = requests
    },
    SET_REQUEST_IDS(state, requestIds) {
      state.listingRequestIds = {}
      for (var i = 0; i < requestIds.length; i++) {
        var id = requestIds[i]._id
        state.listingRequestIds[id] = 1
      }
    },
    REMOVE_REQUEST_ID(state, rId) {
      delete state.listingRequestIds[rId]
    },
    RESET_REQUESTS_STATE(state) {
      state.listingRequests = []
      state.listingRequestIds = {}
    },
  },
  actions: {
    removeRequest: (context, requestId) => {
      context.commit("REMOVE_REQUEST", requestId)
      context.commit("REMOVE_REQUEST_ID", requestId)
    },
    updateFees: async (context, { propertyId, fees }) => {
        if (!propertyId || !Object.keys(fees).length) {
            return;
        }
        const result = await updateFees({ propertyId, fees });
        if (!result) {
          return;
        }
        context.commit('UPDATE_FEES', fees);
    },
  }
}

// *** LEGEND ***
// this.$store.state.visitedPagesModule.basic1
// this.$store.dispatch('visitPage', 'BASIC1');
// this.$store.dispatch('unVisitPage', 'BASIC1');
// this.$store.dispatch('unVisitAllPages');
let initialStateVisitedPages = {
  "basic1": false,
  "pre1": false,
  "pre2": false,
  "basic2": false,
  "basic3": false,
  "basic4": false,
  "basic5": false,
  "basic6": false,
  "scene1": false,
  "scene1_1": false,
  "scene2": false,
  "price1": false,
  "price2": false,
  "price3": false,
  "price4": false,
  "address": false,
  "terms": false
}
const visitedPagesModule = {
  state: {
    basic1: false,
    basic2: false,
    basic3: false,
    basic4: false,
    basic5: false,
    address: false,
    scene1: false,
    scene1_1: false,
    scene2: false,
    price1: false,
    price2: false,
    price3: false,
    price4: false,
    terms: false
  },
  getters: {
    basic1Visited: state => state.basic1,
    basic2Visited: state => state.basic2,
    basic3Visited: state => state.basic3,
    basic4Visited: state => state.basic4,
    basic5Visited: state => state.basic5,
    addressVisited: state => state.address,
    scene1Visited: state => state.scene1,
    scene2Visited: state => state.scene2,
    scene1_1Visited: state => state.scene1_1,
    price1Visited: state => state.price1,
    price2Visited: state => state.price2,
    price3Visited: state => state.price3,
    price4Visited: state => state.price4
  },
  mutations: {
    BASIC1(state, payload) {
      state.basic1 = payload
    },
    BASIC2(state, payload) {
      state.basic2 = payload
    },
    BASIC3(state, payload) {
      state.basic3 = payload
    },
    BASIC4(state, payload) {
      state.basic4 = payload
    },
    BASIC5(state, payload) {
      state.basic5 = payload
    },
    ADDRESS(state, payload) {
      state.address = payload
    },
    SCENE1_1(state, payload) {
      state.scene1_1 = payload
    },
    SCENE1(state, payload) {
      state.scene1 = payload
    },
    SCENE2(state, payload) {
      state.scene2 = payload
    },
    PRICE1(state, payload) {
      state.price1 = payload
    },
    PRICE2(state, payload) {
      state.price2 = payload
    },
    PRICE3(state, payload) {
      state.price3 = payload
    },
    PRICE4(state, payload) {
      state.price4 = payload
    },
    TERMS(state, payload) {
      state.terms = payload
    },
    RESET_VISITED_PAGES(state) {
      Object.keys(state).forEach(key => {
        state[key] = initialStateVisitedPages[key].toString();
      })
    }
  },
  actions: {
    visitPage(context, page) {
      // use contex to access state, getters and modules
      // to invoice this action call this.$store.dispatch('visitPage', 'PAGE_MUTATION');
      context.commit(page, true)
    },
    unVisitPage(context, page) {
      // use contex to access state, getters and modules
      // to invoice this action call this.$store.dispatch('visitPage', 'PAGE_MUTATION');
      context.commit(page, false)
    },
    unVisitAllPages(context) {

    }
  }
}

const listingProgressModule = {
  state: {
    listingProgress: "NOT_ADDED",
    addedListingObjectId: "",
    listingCreationDate: "",
    userUIdWhoIsAddingListing: "",
  },
  getters: {
    listingProgress: state => state.listingProgress,
    addedListingObjectId: state => state.addedListingObjectId,
    listingCreationDate: state => state.listingCreationDate,
    userUIdWhoIsAddingListing: state => state.userUIdWhoIsAddingListing
  },
  mutations: {
    LISTING_ADDED(state, listingObjectId) {
      state.listingProgress = "LISTING_ADDED"
      state.addedListingObjectId = listingObjectId
    },
    LISTING_PENDING(state) {
      state.listingProgress = "LISTING_PENDING"
    },
    LISTING_NOT_ADDED(state) {
      state.listingProgress = "LISTING_NOT_ADDED"
    },
    setListingCreationDate(state, payload) {
      state.listingCreationDate = payload
    },
    // setUserUIdWhoIsAddingListing(state, payload){
    //   state.userUIdWhoIsAddingListing = payload
    // },
    RESET_LISTING_ADD_PROGRESS(state) {
      state.listingProgress = "NOT_ADDED";
      state.addedListingObjectId = "";
      state.listingCreationDate = "";
      state.userUIdWhoIsAddingListing = "";
    }
  }
}

const listingModule = {
  state: JSON.parse(JSON.stringify(listingModel)),
  getters: {
    location: state => state.location,
    googLocation: state => state.googLocation,
    address: state => state.location.address,
    techDet: state => state.techDet,
    genDet: state => state.genDet,
    marketingDet: state => state.marketingDet,
    txnDet: state => state.txnDet,
    availDet: state => state.availDet,
    listing: state => state,
    fees: state => state.fees,
  },
  mutations: {
    UPDATE_GOOG_LOCATION(state, payload) {
      state.googLocation = payload
    },
    UPDATE_LOCATION_ENTIRE(state, payload) {
      state.location = payload
    },
    UPDATE_LOCATION(state, payload) {
      state.location.address = payload
    },
    UPDATE_GENDET(state, payload) {
      state.genDet = payload
    },
    UPDATE_TECHDET(state, payload) {
      state.techDet = payload
    },
    UPDATE_MARKETINGDET(state, payload) {
      state.marketingDet = payload
    },
    UPDATE_TXNDET(state, payload) {
      state.txnDet = payload
    },
    UPDATE_AVAILDET(state, payload) {
      state.availDet = payload
    },
    UPDATE_FEES(state, fees) {
      state.fees = fees;
    },
    RESET_LISTING(state) {
      state.location = JSON.parse(JSON.stringify(listingModel.location));
      state.googLocation = JSON.parse(JSON.stringify(listingModel.googLocation));
      state.techDet = JSON.parse(JSON.stringify(listingModel.techDet));
      state.genDet = JSON.parse(JSON.stringify(listingModel.genDet));
      state.marketingDet = JSON.parse(JSON.stringify(listingModel.marketingDet));
      state.txnDet = JSON.parse(JSON.stringify(listingModel.txnDet));
      state.availDet = JSON.parse(JSON.stringify(listingModel.availDet));
      state.fees = JSON.parse(JSON.stringify(listingModel.fees));
    }
  },
  actions: {
    async checkPropertyAddress(context, { city, street, streetNumber = null, apartmentNumber = null }) {
      if (!city || !street) {
        throw new Error('city and street are required fields');
      }
      if (!streetNumber && !apartmentNumber) {
        throw new Error('either streetNumber or apartmentNumber are required');
      }

      return await checkPropertyAddress({ city, street, streetNumber, apartmentNumber });
    },
  }
};


let initialStateProperties = {
  activeProperties: [],
  draftProperties: [],
  archivedProperties: [],
  propertyNotes: {}
}
const propertiesModule = {
  state: {
    propertyNotes: {},
    activeProperties: [],
    draftProperties: [],
    archivedProperties: [],
    filteredActiveProperties: [],
    filteredDraftProperties: [],
    canLoadMoreActiveProperties: true,
    canLoadMoreDraftProperties: true,
    canLoadMoreArchivedProperties: true,
    pageLimit: 15,
    propertiesRequestPending: false,
  },
  getters: {
    propertyNotes: state => state.propertyNotes,
    activeProperties: state => state.activeProperties,
    draftProperties: state => state.draftProperties,
    archivedProperties: state => state.archivedProperties,
    filteredActiveProperties: state => state.filteredActiveProperties,
    filteredDraftProperties: state => state.filteredDraftProperties,
    canLoadMoreActiveProperties: state => state.canLoadMoreActiveProperties,
    canLoadMoreDraftProperties: state => state.canLoadMoreDraftProperties,
    canLoadMoreArchivedProperties: state => state.canLoadMoreArchivedProperties,
    pageLimit: state => state.pageLimit,
    propertiesRequestPending: state => state.propertiesRequestPending,
    activePropertiesPageNumber: state => {
        return Math.ceil(state.activeProperties.length / state.pageLimit);
    },
    draftPropertiesPageNumber: state => {
        return Math.ceil(state.draftProperties.length / state.pageLimit);
    },
    archivedPropertiesPageNumber: state => {
        return Math.ceil(state.archivedProperties.length / state.pageLimit);
    },
  },
  mutations: {
    ADD_PROPERTY_NOTE(state, {propertyId, note}){
      if(!state.propertyNotes[propertyId]) Vue.set(state.propertyNotes, propertyId, [])
      state.propertyNotes[propertyId].push(note)
    },
    REPLACE_PROPERTY_NOTE(state, {propertyId, note}){
      for (let i = 0, n = state.propertyNotes[propertyId].length; i < n; i++) {
        if(state.propertyNotes[propertyId][i]._id == note._id){
          state.propertyNotes[propertyId][i] = note
          var ns = state.propertyNotes[propertyId]
          Vue.set(state.propertyNotes, propertyId, ns)
          return;
        }
      }
    },
    REMOVE_PROPERTY_NOTE(state, {propertyId, noteId}){
      if(!state.propertyNotes[propertyId]) return;
      
      for (let i = 0, n = state.propertyNotes[propertyId].length; i < n; i++) {
        if(state.propertyNotes[propertyId][i]._id == noteId){
          state.propertyNotes[propertyId].splice(i, 1);
          return;
        }
      }
    },
    SET_PROPERTY_NOTES(state, {propertyId, notes}){
      Vue.set(state.propertyNotes, propertyId, notes)
    },
    RESET_PROPERTIES_STATE(state, payload) {
      state.activeProperties = JSON.parse(JSON.stringify(initialStateProperties.activeProperties));
      state.draftProperties = JSON.parse(JSON.stringify(initialStateProperties.draftProperties));
      state.archivedProperties = JSON.parse(JSON.stringify(initialStateProperties.archivedProperties));
      state.propertyNotes = JSON.parse(JSON.stringify(initialStateProperties.propertyNotes));
    },
    SET_ACTIVE_PROPERTIES(state, payload) {
      state.activeProperties = payload
    },
    SET_DRAFT_PROPERTIES(state, payload) {
      state.draftProperties = payload
    },
    SET_ARCHIVED_PROPERTIES(state, payload) {
      state.archivedProperties = payload
    },
    APPEND_ACTIVE_PROPERTIES(state, payload) {
      state.activeProperties = state.activeProperties.concat(payload);
    },
    APPEND_DRAFT_PROPERTIES(state, payload) {
      state.draftProperties = state.draftProperties.concat(payload);
    },
    APPEND_ARCHIVED_PROPERTIES(state, payload) {
      state.archivedProperties = state.archivedProperties.concat(payload);
    },
    ADD_DRAFT_PROPERTY(state, payload) {
      state.draftProperties.push(payload)
    },
    CLEAR_ACTIVE_PROPERTIES(state) {
      state.activeProperties = [];
      state.canLoadMoreActiveProperties = true;
    },
    CLEAR_DRAFT_PROPERTIES(state) {
      state.draftProperties = [];
      state.canLoadMoreDraftProperties = true;
    },
    CLEAR_ARCHIVED_PROPERTIES(state) {
      state.archivedProperties = [];
      state.canLoadMoreArchivedProperties = true;
    },
    CLEAR_ALL_PROPERTIES(state) {
      state.activeProperties = []
      state.draftProperties = []
      state.archivedProperties = [];
      state.filteredActiveProperties = [];
      state.filteredDraftProperties = [];
      state.canLoadMoreActiveProperties = true;
      state.canLoadMoreDraftProperties = true;
      state.canLoadMoreArchivedProperties = true;
    },
    UPSERT_PROPERTY(state, property) {
      if (!property) return
      var fromList
      if (property.availDet.status == "active") fromList = state.activeProperties
      if (property.availDet.status == "draft") fromList = state.draftProperties
      if (property.availDet.status == "archived") fromList = state.archivedProperties

      // let exists=false
      for (var i = 0; i < fromList.length; i++) {
        if (fromList[i].maaklerID == property.maaklerID) {
          // exists=true
          fromList.splice(i, 1)
          break;
        }
      }
      fromList.push(property)
    },
    REMOVE_PROPERTY_BY_MID(state, property) {
      var fromList
      if (property.availDet.status == "active") fromList = state.activeProperties
      if (property.availDet.status == "draft") fromList = state.draftProperties
      if (property.availDet.status == "archived") fromList = state.archivedProperties

      for (var i = 0; i < fromList.length; i++) {
        if (fromList[i].maaklerID == property.maaklerID) {
          fromList.splice(i, 1);
          return;
        }
      }
    },
      setCanLoadMoreActiveProperties: (state, canLoadMoreActiveProperties) => {
        state.canLoadMoreActiveProperties = Boolean(canLoadMoreActiveProperties);
      },
      setCanLoadMoreDraftProperties: (state, canLoadMoreDraftProperties) => {
        state.canLoadMoreDraftProperties = Boolean(canLoadMoreDraftProperties);
      },
      setCanLoadMoreArchivedProperties: (state, canLoadMoreArchivedProperties) => {
        state.canLoadMoreArchivedProperties = Boolean(canLoadMoreArchivedProperties);
      },
      setPropertiesRequestPending: (state, propertiesRequestPending) => {
        state.propertiesRequestPending = Boolean(propertiesRequestPending);
      },
      setFilteredActiveProperties: (state, filteredActiveProperties) => {
        if (!Array.isArray(filteredActiveProperties)) {
          return;
        }
        state.filteredActiveProperties = filteredActiveProperties;
      },
      setFilteredDraftProperties: (state, filteredDraftProperties) => {
        if (!Array.isArray(filteredDraftProperties)) {
          return;
        }
        state.filteredDraftProperties = filteredDraftProperties;
      },
      resetFilteredActiveProperties: (state) => {
        state.filteredActiveProperties = [];
      },
      resetFilteredDraftProperties: (state) => {
        state.filteredDraftProperties = [];
      },
  },
  actions: {
    removePropertyNote({ state, commit }, {propertyId, note, accountId}){
      commit("REMOVE_PROPERTY_NOTE", {propertyId: propertyId, noteId: note._id})
      uploadNote(note, propertyId, accountId)
    },
    async upsertPropertyNote({ state, commit }, {accountId, propertyId, note}){
      if(note._id) commit("REPLACE_PROPERTY_NOTE", {propertyId, note})
      else commit("ADD_PROPERTY_NOTE", {propertyId, note})
      var n = await uploadNote(note, propertyId, accountId)
      commit("REPLACE_PROPERTY_NOTE", {propertyId: propertyId, note: n})

    },
    async getAllPropertyNotes({ state, commit }, {accountId, propertyId, reset}){
      if(reset) commit("SET_PROPERTY_NOTES",  {propertyId: propertyId, notes: []})
      if(state.propertyNotes[propertyId]) return state.propertyNotes[propertyId]
      var notes = await getPropertyNotes(propertyId, accountId)
      commit("SET_PROPERTY_NOTES",  {propertyId: propertyId, notes: notes})
    },
    getProperty(context, { maaklerID }) {
      return new Promise((resolve, reject) => {
        getListingPrivate(maaklerID)
          .then(data => {
            resolve(data)
          })
          .catch(err => {
            reject("Cannot retrieve property for now")
          })
      })
    },
    cloneProperty(context, { property }) {
      return new Promise((resolve, reject) => {
        if (!property || !property._id) {
          reject("Specify property to clone")
          return;
        }
        cloneListing({ propertyId: property._id, accountId: context.getters.connectedAccountIds[0] })
          .then(clonedProperty => {
            if (context.getters.draftProperties.length) {
              context.commit("ADD_DRAFT_PROPERTY", clonedProperty);
            }
            resolve()
          })
          .catch(err => {
            reject()
          })
      })
    },
    moveProperty(context, payload) {
      let fromStatus = payload.fromStatus
      let property = payload.property
      var fromList
      if (fromStatus == "active") fromList = context.getters.activeProperties
      if (fromStatus == "draft") fromList = context.getters.draftProperties
      if (fromStatus == "archived") fromList = context.getters.archivedProperties

      for (var i = 0; i < fromList.length; i++) {
        if (fromList[i]._id == property._id) {
          let p = fromList.splice(i, 1)
          context.commit("UPSERT_PROPERTY", p[0])
        }
      }
    },
    SET_ACTIVE_PROPERTIES({ state, commit }, properties) {
      commit('SET_ACTIVE_PROPERTIES', properties);
      commit('setCanLoadMoreActiveProperties', properties.length >= state.pageLimit);
    },
    SET_DRAFT_PROPERTIES({ state, commit }, properties) {
      commit('SET_DRAFT_PROPERTIES', properties);
      commit('setCanLoadMoreDraftProperties', properties.length >= state.pageLimit);
    },
    SET_ARCHIVED_PROPERTIES({ state, commit }, properties) {
      commit('SET_ARCHIVED_PROPERTIES', properties);
      commit('setCanLoadMoreArchivedProperties', properties.length >= state.pageLimit);
    },
    APPEND_ACTIVE_PROPERTIES({ state, commit }, properties) {
      commit('APPEND_ACTIVE_PROPERTIES', properties);
      commit('setCanLoadMoreActiveProperties', properties.length >= state.pageLimit);
    },
    APPEND_DRAFT_PROPERTIES({ state, commit }, properties) {
      commit('APPEND_DRAFT_PROPERTIES', properties);
      commit('setCanLoadMoreDraftProperties', properties.length >= state.pageLimit);
    },
    APPEND_ARCHIVED_PROPERTIES({ state, commit }, properties) {
      commit('APPEND_ARCHIVED_PROPERTIES', properties);
      commit('setCanLoadMoreArchivedProperties', properties.length >= state.pageLimit);
    },
    async filterActiveProperties({ commit }, searchString) {
        try {
            if (!searchString) {
                return;
            }
            commit("setPropertiesRequestPending", true);
            commit("resetFilteredActiveProperties");
            const properties = await filterProperties({ searchString, status: 'active' });
            commit('setFilteredActiveProperties', properties);
        }
        catch (error) {
            console.log("store | filterActiveProperties > err:", error);
        }
        finally {
            commit("setPropertiesRequestPending", false);
        }
    },
    async filterDraftProperties({ commit }, searchString) {
        try {
            if (!searchString) {
                return;
            }
            commit("setPropertiesRequestPending", true);
            commit("resetFilteredDraftProperties");
            const properties = await filterProperties({ searchString, status: 'draft' });
            commit('setFilteredDraftProperties', properties);
        }
        catch (error) {
            console.log("store | filterDraftProperties > err:", error);
        }
        finally {
            commit("setPropertiesRequestPending", false);
        }
    },
    resetFilteredActiveProperties({ commit }) {
      commit('resetFilteredActiveProperties');
    },
    resetFilteredDraftProperties({ commit }) {
      commit('resetFilteredDraftProperties');
    },
  }
}

const initStateDealApplication = {
  property: {
    propertyId: "",
  },
  lessor: {
    ownerPersonType: "",
    ownerPersonId: "",
    repPrivPersonId: "",
    repJurPersonId: "",
    email: "",
    address: ""
  },
  contract: {
    contractType: ""
  },
  terms: {
    periodStart: "",
    termless: false,
    periodEnd: "",
    price: undefined,
    term: "monthly",
    deposit: undefined,
    nrOfGuests: undefined,
    noticeGiven: undefined,
    noticePeriod: undefined,
    additionalFees: [
      { desc: "", fee: undefined }
    ],
    rentDueDay: undefined,
    accountingPeriod: {
      startDay: undefined,
      endDay: undefined
    }
  },
  houseRules: {
    smoking: false,
    pets: false,
    events: false,
    sublease: false,
    disabilities: false,
    kids: false
  }
}

const dealApplicationModule = {
  state: {
    property: {
      propertyId: undefined,
    },
    lessor: {
      ownerPersonType: "",
      ownerPersonId: "",
      repPrivPersonId: "",
      repJurPersonId: "",
      ownerEmail: "",
      ownerAddress: "",
      repEmail: "",
      repAddress: ""
    },
    lessee: { //not used as this is final step and the values are set directly
      lesseePrivatePersonId: "",
      lesseeJurPersonId: "",
      lesseeRep: "",
      lesseeAddress: "",
      lesseeEmail: ""
    },
    contract: {
      contractType: ""
    },
    terms: {
      periodStart: undefined,
      periodEnd: undefined,
      termless: false,
      price: undefined,
      monthly: true,
      deposit: undefined,
      nrOfGuests: undefined,
      noticeGiven: undefined,
      noticePeriod: undefined,
      additionalFees: [
        { desc: "", fee: undefined }
      ],
      rentDueDay: 10,
      accountingPeriod: {
        startDay: undefined,
        endDay: undefined
      }
    },
    houseRules: {
      smoking: false,
      pets: false,
      events: false,
      sublease: false,
      disabilities: false,
      kids: false
    },
    lessorAccountId: undefined,
    lesseeAccountId: undefined
  },
  getters: {
    getField,
    dealApplication: state => state,
    property: state => state.property,
    lessor: state => state.lessor,
    contract: state => state.contract,
    terms: state => state.terms,
    houseRules: state => state.houseRules,
    lesseeAccountId: state => state.lesseeAccountId,
    lessorAccountId: state => state.lessorAccountId
  },
  mutations: {
    updateField,
    DA_SET(state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = JSON.parse(JSON.stringify(payload[key]));
      })
    },
    DA_RESET(state) {
      Object.keys(state).forEach(key => {
        state[key] = JSON.parse(JSON.stringify(initStateDealApplication[key]));
      })
    },
    DA_SET_PROPERTY(state, payload) {
      state.property = payload
    },
    DA_SET_HOUSE_RULES(state, payload) {
      state.houseRules = payload
    },
    DA_SET_LESSEE(state, payload) {
      state.lessee = payload
    },
    DA_SET_LESSOR(state, payload) {
      state.lessor = payload
    },
    DA_RESET_LESSOR(state) {
      state.lessor = JSON.parse(JSON.stringify(initStateDealApplication.lessor));
    },
    DA_SET_CONTRACT(state, payload) {
      state.contract = payload
    },
    DA_SET_PERIOD_START(state, payload) {
      state.terms.periodStart = payload
    },
    DA_SET_PERIOD_END(state, payload) {
      state.terms.periodEnd = payload
    },
    DA_SET_LESSOR_ACCOUNT_ID(state, payload) {
      state.lessorAccountId = payload
    },
    DA_SET_LESSEE_ACCOUNT_ID(state, payload) {
      state.lesseeAccountId = payload
    }
  },
  actions: {
  }
}

let initialStatisticsState = {
  listingVisits: {}
}
const statisticsModule = {
  state: {
    listingVisits: {},
  },
  getters: {
    listingVisits: (state) => (listingMID) => {
      return state.listingVisits[listingMID]
    },
  },
  mutations: {
    RESET_LISTING_VISITS(state) {
      Vue.set(state.listingVisits, {})
    },
    SET_LISTING_VISITS(state, { listingMID, visits }) {
      Vue.set(state.listingVisits, listingMID, visits)
    }
  },
  actions: {
    downloadListingVisits(context, { listingMID }) {
      getListingVisits(listingMID)
        .then(visits => {
          context.commit("SET_LISTING_VISITS", { listingMID, visits })
        })
        .catch(err => {
        })
    },
  }
}

export default new Vuex.Store({
  modules: {
    listingProgressModule: listingProgressModule,
    listingModule: listingModule,
    visitedPagesModule: visitedPagesModule,
    //chatModule: chatModule,
    chatModule: ChatModule,
    readOnceValuesModule: readOnceValuesModule,
    listingsPortalModule: listingsPortalModule,
    listingRequestsModule: listingRequestsModule,
    listingBookingsModule: listingBookingsModule,
    userModule: userModule,
    accountModule: AccountModule,
    utilityModule: utilityModule,
    propertiesModule: propertiesModule,
    dealApplicationModule: dealApplicationModule,
    statisticsModule: statisticsModule,
    propertyCalendarModule: PropertyCalendarModule,
    contractTemplatesModule: ContractTemplatesModule,
    internationalizationModule: InternationalizationModule,
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js